import React from 'react';
import { Typography, Card, Row, Col } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import SellerProfile from '../components/SellerProfile';

const { Title } = Typography;

const Profile: React.FC = () => {
  // Get user data from localStorage
  const userData = localStorage.getItem('user');
  let user = null;
  
  if (userData) {
    try {
      user = JSON.parse(userData);
    } catch (error) {
      console.error('Error parsing user data:', error);
    }
  }

  return (
    <div>
      <div style={{ marginBottom: '24px' }}>
        <Title level={2}>
          <UserOutlined /> Profile
        </Title>
        <p style={{ color: '#666', marginTop: '8px' }}>
          View and manage your profile information
        </p>
      </div>

      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Card>
            {user ? (
              <SellerProfile 
                sellerId={user.id} 
                identifier={user.email || user.username} 
              />
            ) : (
              <div style={{ textAlign: 'center', padding: '40px' }}>
                <UserOutlined style={{ fontSize: '48px', color: '#d9d9d9', marginBottom: '16px' }} />
                <p style={{ fontSize: '16px', color: '#999' }}>No profile data available</p>
                <p style={{ fontSize: '12px', color: '#ccc' }}>Please log in to view your profile</p>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Profile;
